import axios from 'axios';
import Cookies from 'js-cookie';

import { openModal } from '@help/modal.js';
import { validator400, validator400Plus } from '@utils/input_validator.js';
import { maskedTelInputs } from '@utils/masked_tel_inputs.js';
import { inputsCleanCrossHandler } from '@utils/inputs_with_clean_cross.js';
import { gtagReportConversion } from '@integrations/gtag_send_conversion.js';


export function submitForm(quoteForm, payDeposit = false) {
  const errorTexts = quoteForm.querySelectorAll('.error-basic-text');
  const apiUrl = '/api/v1/quote/create/';
  const inputs = quoteForm.querySelectorAll('.form-input');
  const formData = {
    first_name: '',
    phone: '',
    date: '',
    move_from: '',
    move_to: '',
    email: '',
  };

  collectFormData();

  const csrfToken = Cookies.get('csrftoken');
  axios.defaults.headers.common['X-CSRFToken'] = csrfToken;
  return axios.post(apiUrl, formData)
    .then(response => {
      const quoteId = response.data.data.item.quoteId;
      if (!payDeposit) {
        const text = 'Thank you!<br>Our manager will contact you very soon!';
        openModal(text);
        cleanFormInputs(quoteForm);
      }

      dataLayer.push({ event: 'order_complete' }); // for google tag manager
      gtagReportConversion();

      // Meta analytics
      if (typeof fbq !== 'undefined') {
        fbq('track', 'Lead');
      }

      // uet_report_conversion(); // for Bing Ads
      return quoteId
    })
    .catch(error => {
      console.log('error', error)
      if (400 < error.response.status) {
        validator400Plus(inputs, errorTexts);
      } else {
        validator400(
          error.response.data.errors[0].state,
          inputs,
          errorTexts,
          false,
          true
        );
      };
    });

    function collectFormData() {
      inputs.forEach(input => {
        formData[input.name] = input.value;
      });
    };
  };

export async function quoteFormHandler() {
  const quoteForm = document.querySelector('.create-quote-form');

  if (quoteForm) {
    const submitButton = quoteForm.querySelector('.get-quote-btn');

    maskedTelInputs();
    inputsCleanCrossHandler();
    setDateToTomorrow(quoteForm);

    submitButton.addEventListener('click', () => {
      submitButton.classList.add('disabled');

      submitForm(quoteForm);

      window.setTimeout(() => {
        submitButton.classList.remove('disabled');
      }, 3000);
    })
  }

}

export function cleanFormInputs(quoteForm) {
  const inputs = quoteForm.querySelectorAll('.form-input');
  inputs.forEach(element => {
    element.value = '';
    element.nextElementSibling.classList.remove('has-content');
  });
  setDateToTomorrow(quoteForm);
}

function setDateToTomorrow(quoteForm) {
  const today = new Date();
  const tomorrow = new Date(today.getTime() + 24 * 60 * 60 * 1000);
  const tomorrowFormatted = `${tomorrow.getMonth() + 1}-${tomorrow.getDate()}-${tomorrow.getFullYear()}`;
  quoteForm.querySelector('.date-input').value = tomorrowFormatted;
}
